import { render } from "./EeventAssets.vue?vue&type=template&id=55f2d7c2&scoped=true"
import script from "./EeventAssets.vue?vue&type=script&lang=js"
export * from "./EeventAssets.vue?vue&type=script&lang=js"

import "./EeventAssets.vue?vue&type=style&index=0&id=55f2d7c2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55f2d7c2"]])

export default __exports__